import { GraphVisualizationFilterElements } from '@ardoq/color-helpers';
import { MODERNIZED_BLOCK_DIAGRAM_LEAF_IMAGE_CLIP_PATH } from './consts';

const GraphVisualizationSvgDefElements = () => (
  <>
    <GraphVisualizationFilterElements />
    <clipPath
      id={MODERNIZED_BLOCK_DIAGRAM_LEAF_IMAGE_CLIP_PATH}
      clipPathUnits="objectBoundingBox"
    >
      <circle cx="0.5" cy="0.5" r="0.5" />
    </clipPath>
  </>
);
export { GraphVisualizationSvgDefElements };
